document.addEventListener("DOMContentLoaded", function () {
  const modalTriggers = document.querySelectorAll("[data-modal^='modal1']");
  const modals = document.querySelectorAll(".modal1");

  // モーダルを開く
  modalTriggers.forEach((trigger) => {
    trigger.addEventListener("click", function () {
      const modalId = this.getAttribute("data-modal");
      const modal = document.getElementById(modalId);
      if (modal) {
        modal.style.display = "block";
        setTimeout(() => {
          modal.classList.add("show");
        }, 10);
      }
    });
  });

  // モーダルを閉じる
  const closeButtons = document.querySelectorAll(".modal1 .close");
  closeButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const modal = this.closest(".modal1");
      modal.classList.remove("show");
      setTimeout(() => {
        modal.style.display = "none";
      }, 300);
    });
  });

  // モーダル外をクリックして閉じる
  window.addEventListener("click", function (event) {
    modals.forEach((modal) => {
      if (event.target === modal) {
        modal.classList.remove("show");
        setTimeout(() => {
          modal.style.display = "none";
        }, 300);
      }
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const modals = document.querySelectorAll(".modal1");

  modals.forEach((modal) => {
    document.body.appendChild(modal); 
  });
});